// extracted by mini-css-extract-plugin
export default {"manage":"Manage_manage__loEWw","sectionHeader":"Manage_sectionHeader__Xr5ZX","entityDetails":"Manage_entityDetails__xRAL6","nav":"Manage_nav__ohzio","detail":"Manage_detail__Yp+fH"};